import PageTopNavV2 from "components/PageTopNavV2";
import { ISectionMenuItem } from "components/PageTopNav";
import LoginBox from "./LoginBox";
import { Container, LoginBoxWrapper, NoSessionContent } from "./styles";
import bgShop from "assets/bg-shop.jpg";

interface Props {
	bgImageUrl?: string;
	sectionMenuData?: ISectionMenuItem[];
	loginBoxTitle?: string;
	loginBoxSubtitle?: string;
	loginBoxSource?: string;
}

const NoSessionLayout = ({
	bgImageUrl = bgShop,
	sectionMenuData = [],
	loginBoxTitle,
	loginBoxSubtitle,
	loginBoxSource
}: Props) => {
	return (
		<Container bgImageUrl={bgImageUrl}>
			<NoSessionContent>
				<PageTopNavV2
					sectionMenuData={sectionMenuData}
					hasSectionBanner={false}
					transparentMainBackground={true}
				/>
				<LoginBoxWrapper>
					<LoginBox
						title={loginBoxTitle}
						subtitle={loginBoxSubtitle}
						source={loginBoxSource}
					/>
				</LoginBoxWrapper>
			</NoSessionContent>
		</Container>
	);
};

export default NoSessionLayout;
